<!--
  AI:
  Status: "in progress"
  Type: Component
  SubType: CrudIntegration
  Reason: Listet Ticketgruppenfilter und bettet ein <mvs-widget> mit uiComponent='object' für Anlage und Bearbeitung von tm.TicketGroupFilter ein.
  Ticket: TM-1000001563
-->
@if (initialized) {
    @if(currentView == 'allFilters') {
        <div class="flex justify-content-between align-items-center border-bottom-1 border-200 pb-2">
            <h4 class="m-0">Erstellte Filter</h4>
            <p-button pTooltip="Filter erstellen" icon="pi pi-plus-circle text-xl" styleClass="p-button-text"
                      (click)="handleCreateFilter()"></p-button>
        </div>
        <div class="group-list" *ngIf="groupFilters && groupFilters.length">
            @for (group of groupFilters; track group.id) {
                <div class="group-item flex justify-content-between align-items-center mt-1 p-2">
                    <div class="group-title">
                        &nbsp;{{ group.name }}
                    </div>
                    <div class="flex gap-2 align-items-center">
                        @if (group.access == TicketGroupFilterAccess.public_access) {
                            <p-badge value="Public" severity="success" styleClass="badge-style"></p-badge>
                        } @else if (group.access == TicketGroupFilterAccess.private_access) {
                            <p-badge value="Private" styleClass="badge-style"></p-badge>
                        }

                        <p-button [icon]="'fa-regular fa-pencil pointer'" [disabled]="group.access == TicketGroupFilterAccess.private_access" styleClass="p-button-text" (click)="handleEditFilter(group)"></p-button>
                        <!-- TM-1000001457: Added click handler for delete functionality -->
                        <p-button [icon]="'fa-regular fa-trash pointer'" [disabled]="group.access == TicketGroupFilterAccess.private_access" styleClass="p-button-text" (click)="handleDeleteFilter(group)"></p-button>
<!--                        <i class="fa-regular fa-pencil ml-2 pointer" (click)="handleEditFilter(group)"></i>-->
<!--                        <i class="fa-regular fa-trash ml-2 pointer"></i>-->

                    </div>
                </div>
            }
        </div>
    } @else if (currentView != 'allFilters') {

        <div (click)="handleMainNavigation()" class="pointer mt-2">
            <i class="fa-solid fa-chevron-left"></i> Zurück zu allen Filtern
        </div>
        <hr>

        @if (currentView == 'createFilter') {
            <!-- TM-1000001563: <mvs-widget> with uiComponent='object' replaces <mvs-object>
                 to avoid GET /mvsa/tm/ticketGroupFilters/0 (404) on create. -->
            <mvs-widget
                    [widgetData]="createFilterWidget"
                    (onChangedObject)="handleFilterChanged($event)">
            </mvs-widget>
        }

        @if (currentView == 'updateFilter') {
            <!-- TM-1000001563: same canonical pattern; objectId=selectedGroup.id triggers update mode. -->
            <mvs-widget
                    *ngIf="selectedGroup"
                    [widgetData]="updateFilterWidget"
                    (onChangedObject)="handleFilterChanged($event)">
            </mvs-widget>
        }


    }

}